module.exports = __webpack_public_path__ + "static/media/img_404_dark.d07cad8d.png";